import React from 'react'
import { Card, Carousel } from 'react-bootstrap'
import { S3Media } from '../../third-party-services'
import './company-detail.css'

/**
 * ProductGallery Component
 * 
 * Displays product images in a Bootstrap Carousel/slideshow format. Maps through
 * products array and nested image arrays to render carousel items with product photos.
 * Images are retrieved from S3 storage via S3Media URL prefix. Provides interactive
 * navigation through product images with previous/next controls.
 * 
 * @param {Object} props - Component props
 * @param {Array} props.products - Array of product objects containing images array
 * @param {string} props.tradeName - Company trade name for image alt text
 * @returns {JSX.Element} Card body with product image carousel
 */
function ProductGallery(props) {

    return (
        <Card.Body id="productgallery">
            <div className="companydetailproductdiv">
                {/* Display product images in carousel/slideshow format with navigation controls */}
                <Carousel>
                    {!props?.products
                        ? ("")
                        : props.products.map((product, index) =>
                            product.images.map((image, index) =>
                                <Carousel.Item key={index}>
                                    <img src={S3Media + 'assets/photos/products/' + image.image} alt={props.tradeName} className="companydetailproductimage" />
                                </Carousel.Item>
                            )
                        )}
                </Carousel>
            </div>
        </Card.Body>
    )
}

export default ProductGallery;